module.exports = __webpack_public_path__ + "static/world-61cc5eec2d690c3d1798a2debcb3ae21.png";